import _toConsumableArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/usr/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
export var getStepStatus = function getStepStatus(step, details) {
  if (step.cancelled === true || step.completed === -1) return "cancelled";
  if (step.completed === true || step.completed === 1) return "done";
  if (step.status_key === details.current || step.current === true || step.current === 1) return "current";
  return "pending";
};
export var getCurrentStep = function getCurrentStep(details) {
  var _details$steps;
  return details === null || details === void 0 ? void 0 : (_details$steps = details.steps) === null || _details$steps === void 0 ? void 0 : _details$steps.find(function (step) {
    return getStepStatus(step, details) === "current";
  });
};
export var handleFileChange = function handleFileChange(file, field, setFileObjects, setPreSignData, setUploadDocumentsData) {
  var documentKey = field.document_key;
  var extension = file === null || file === void 0 ? void 0 : file.name.split(".").pop();
  // Update the state with the new file
  setFileObjects(function (prevFileObjects) {
    return _objectSpread(_objectSpread({}, prevFileObjects), {}, _defineProperty({}, documentKey, file));
  });
  setPreSignData(function (prevPreSignData) {
    return _objectSpread(_objectSpread({}, prevPreSignData), {}, _defineProperty({}, documentKey, {
      path: field.path,
      extension: extension // Get the file extension
    }));
  });
  setUploadDocumentsData(function (prevDocuments) {
    return [].concat(_toConsumableArray(prevDocuments), [{
      path: field.path,
      extension: extension,
      name_ar: field.name_ar,
      name_en: field.name_en
    }]);
  });
};
export var deleteFileObject = function deleteFileObject(field, setFileObjects) {
  var documentKey = field.document_key;
  setFileObjects(function (prevFileObjects) {
    // Create a copy of the previous state
    var updatedFileObjects = _objectSpread({}, prevFileObjects);

    // Delete the property with the specified documentKey
    delete updatedFileObjects[documentKey];
    return updatedFileObjects;
  });
};
export var deleteDocuments = function deleteDocuments(field, setUploadDocumentsData) {
  var documentKey = field.path;
  setUploadDocumentsData(function (prevDocuments) {
    // Filter out the document with the matching path
    var updatedDocuments = prevDocuments.filter(function (document) {
      return document.path !== documentKey;
    });
    return updatedDocuments;
  });
};
export var filterFieldsWithFiles = function filterFieldsWithFiles(details) {
  var _details$step_body, _details$step_body$fi;
  if (!(details !== null && details !== void 0 && (_details$step_body = details.step_body) !== null && _details$step_body !== void 0 && (_details$step_body$fi = _details$step_body.fields) !== null && _details$step_body$fi !== void 0 && _details$step_body$fi.values)) {
    return [];
  }
  // Filter out the fields with non-null file values
  return details.step_body.fields.values.filter(function (field) {
    return (field === null || field === void 0 ? void 0 : field.file) !== null && field.status !== "rejected";
  })
  // Map over each filtered field and update the uploadDocumentsData state
  .map(function (field) {
    var cleanUrl = field === null || field === void 0 ? void 0 : field.file.split("?")[0];
    var parts = cleanUrl.split(".");
    var extension = parts[parts.length - 1];
    return {
      path: field.path,
      extension: extension,
      name_ar: field.name_ar,
      name_en: field.name_en
    };
  });
};